import { render } from "./SinglePaymentButton.vue?vue&type=template&id=1636f7e4&lang=pug"
import script from "./SinglePaymentButton.vue?vue&type=script&lang=js"
export * from "./SinglePaymentButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__